import { useRef } from 'react';
import { ActionButton, Typography, useBreakpoints } from 'ui';
import { useLayout } from '@context/LayoutContext';
import { DefaultButton, StyledStack } from './PageHeaderToolbar.styles';
import { ToolbarItem } from './types';

export function PageHeaderToolbar() {
  const { isMdUp } = useBreakpoints();
  const { toolbarItems } = useLayout();
  const refs = useRef<(HTMLButtonElement | null)[]>([]);

  if (!isMdUp || toolbarItems.length === 0) return null;

  return (
    <StyledStack>
      {toolbarItems.map((item: ToolbarItem, index: number) => {
        if (!item || !item.name) return null;
        const {
          name,
          icon,
          onClick,
          showNameOnDesktop,
          onRender,
          variant = 'action',
          dataTestId,
          ariaLabel,
        } = item;

        const refCallback = (el: HTMLButtonElement | null) => {
          refs.current[index] = el;
          if (onRender && el) onRender(el);
        };

        const commonProps = {
          'aria-label': ariaLabel ?? name,
          'data-testid': dataTestId,
          onClick,
          startIcon: icon,
          ref: refCallback,
        } as const;
        if (onRender) onRender(refs.current[index]);

        return variant === 'action' ? (
          <ActionButton key={name} {...commonProps}>
            {showNameOnDesktop ? (
              <Typography variant="subtitle">{name}</Typography>
            ) : null}
          </ActionButton>
        ) : (
          <DefaultButton
            {...commonProps}
            key={name}
            variant={variant === 'primary' ? 'contained' : 'outlined'}
          >
            {showNameOnDesktop ? (
              <Typography variant="subtitle">{name}</Typography>
            ) : null}
          </DefaultButton>
        );
      })}
    </StyledStack>
  );
}
